import { Camera, PermissionResponse, PermissionStatus } from "expo-camera";
import { ManagedPermission } from "./ManagedPermission";
import { PermissionToken } from "./constants";

export class CameraPermission extends ManagedPermission {
  constructor() {
    super(PermissionToken.Camera);
  }

  protected async getPermissions(): Promise<PermissionResponse> {
    let response = await Camera.getCameraPermissionsAsync();

    // firefox doesn't support getPermissions for camera or microphone
    // we can check if it was previously granted this session and return that
    const isNotSupported = (response as any).querySupported === false;

    if (isNotSupported && this.permitted) {
      response = {
        status: PermissionStatus.GRANTED,
        expires: "never",
        canAskAgain: true,
        granted: true,
      };
    }

    this.permitted = this.isGranted(response);

    return response;
  }

  protected async requestModulePermission(): Promise<PermissionResponse> {
    const res = await Camera.requestCameraPermissionsAsync();
    return res;
  }
}
